import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import MainLayout from '../../components/Layout/MainLayout';
import { 
  Plus, 
  Edit, 
  Trash2, 
  Search, 
  X, 
  Link as LinkIcon, 
  Image as ImageIcon, 
  Upload, 
  ExternalLink, 
  Check, 
  AlertCircle 
} from 'lucide-react';
import './Banners.css';
import { handleGetApi, handlePostApi } from '../../api/api';
import Cookies from 'js-cookie';

const Banners = () => {
  const token = JSON.parse(Cookies.get('auth_token'));
    const headers = {
      Authorization: token
    }

  const [banners, setBanners] = useState([]);
  console.log(banners,'ban')
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);
  const [formData, setFormData] = useState({
    image: '',
    link: '',
    active: true
  });
  console.log(formData,'form')
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadPreview, setUploadPreview] = useState(null);

  // Fetch banners from API
  const fetchBanners = async () => {
    setLoading(true);
    try {
      const res = await handleGetApi('admin/get/banner', headers);
      console.log(res)
      if (res && res.success && res.data && res.data.length > 0) {
        setBanners(res.data);
      } else {
        // Fallback to sample data if database is empty or offline
        setBanners([]);
      }
    } catch (error) {
      console.warn("API Error, falling back to offline mock data:", error);
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // Filter banners based on search query
  const filteredBanners = useMemo(() => {
    if (!search.trim()) return banners;
    const query = search.toLowerCase();
    return banners.filter(item => 
      (item.link && item.link.toLowerCase().includes(query)) ||
      (String(item.active).includes(query))
    );
  }, [banners, search]);
console.log(filteredBanners)
  const handleOpenModal = (banner = null) => {
    if (banner) {
      setEditingBanner(banner);
      setFormData({
        image: banner.image,
        link: banner.link || '',
        active: banner.active
      });

      setUploadedFile(null);
      setUploadPreview(`${process.env.REACT_APP_IMAGE_URL}banner/${banner.image}`);
    } else {
      setEditingBanner(null);
      setFormData({
        image: '',
        link: '',
        active: true
      });
      setUploadedFile(null);
      setUploadPreview(null);
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingBanner(null);
    setUploadedFile(null);
    setUploadPreview(null);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFile(file);
      const objectUrl = URL.createObjectURL(file);
      setUploadPreview(objectUrl);
      // For pure UI/local fallback, we set the filename or mock link
      setFormData(prev => ({
        ...prev,
        image: file // Local preview path
      }));
    }
  };

  // Quick toggle active status from card pill
  const handleToggleStatus = async (banner) => {
    const newStatus = !banner.active
    const updatedBanner = { ...banner, active: newStatus };

    // Optimistic update
    setBanners(prev => prev.map(b => b.id === banner.id ? updatedBanner : b));

    try {
      // Backend expects: POST admin/update/banner/:id
      const payload = {
        image: banner.image,
        link: banner.link,
        active: newStatus
      };
      await handlePostApi(`admin/update/banner/${banner.id}`, payload, headers);
    } catch (error) {
      console.error("Failed to toggle status on server:", error);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // uploaded image preview ya existing image
  const imageValue = uploadPreview || formData.image;

  if (!imageValue) {
    alert("Please select banner image");
    return;
  }
  const payload = new FormData();
    if (formData?.image instanceof File) {
    payload.append("banner", formData.image);
  }
  payload.append('link', formData?.link);
  payload.append('active', formData?.active);

  try {
    // UPDATE Banner
    if (editingBanner) {

      const res = await handlePostApi(
        `admin/update/banner/${editingBanner.id}`,
        payload,
        headers
      );

      setBanners((prev) =>
        prev.map((item) =>
          item.id === editingBanner.id
            ? {
                ...item,
                image: res?.image
                  ? res?.image
                  : item.image,
                link: formData.link,
                active: formData.active,
              }
            : item
        )
      );

    } else {

      // ADD Banner
      const res = await handlePostApi(
        "admin/add/banner",
        payload,
        headers
      );
console.log(res,'res')
      const newBanner = {
        id: res?.insertId || Date.now(),
        image: res?.image,
        link: formData.link,
        active: formData.active,
        created_at: new Date().toISOString(),
      };

      setBanners((prev) => [newBanner, ...prev]);
    }

    handleCloseModal();

  } catch (error) {
    console.log("Banner save error:", error);

    alert("Something went wrong");
  }
};

  const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this banner?")) {
    return;
  }

  try {
    await handlePostApi(`admin/delete/banner/${id}`, {}, headers);

    setBanners((prev) =>
      prev.filter((item) => item.id !== id)
    );

  } catch (error) {
    console.log("Delete error:", error);
  }
};

  return (
    <MainLayout title="Banner Management">
      <div className="banners-container fade-in">
        <div className="banners-header">
          <div className="search-filters">
            <div className="search-input">
              <Search size={18} />
              <input 
                type="text" 
                value={search} 
                onChange={(e) => setSearch(e.target.value)} 
                placeholder="Search by link or status..." 
              />
            </div>
          </div>
          <button className="add-btn" onClick={() => handleOpenModal()}>
            <Plus size={20} />
            <span>Add Banner</span>
          </button>
        </div>

        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading banners...</p>
          </div>
        ) : filteredBanners.length === 0 ? (
          <div className="empty-state">
            <AlertCircle size={48} />
            <h3>No Banners Found</h3>
            <p>Get started by creating your first promotional storefront banner!</p>
            <button className="add-btn-large" onClick={() => handleOpenModal()}>
              <Plus size={20} />
              <span>Add Your First Banner</span>
            </button>
          </div>
        ) : (
          <div className="banners-grid">
            {filteredBanners.map((banner) => (
              <div className="banner-card" key={banner.id}>
                <div className="banner-img-container">
                  <img src={`${process.env.REACT_APP_IMAGE_URL}banner/${banner.image}`} alt="Storefront Promotion" />
                  <div className={`status-badge-overlay ${banner.active ? "active" : "inactive"}`}>
                    {banner.active}
                  </div>
                </div>
                
                <div className="banner-details">
                  <div className="detail-row">
                    <span className="detail-label">
                      <LinkIcon size={14} /> Redirect Link:
                    </span>
                    <span className="detail-value" title={banner.link || 'No redirect link'}>
                      {banner.link ? (
                        <a href={banner.link} target="_blank" rel="noopener noreferrer" className="banner-external-link">
                          {banner.link} <ExternalLink size={12} />
                        </a>
                      ) : (
                        <span className="no-link">None</span>
                      )}
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">Status Toggle:</span>
                    <button 
                      className={`status-pill ${banner.active ? "active" : "inactive"}`}
                      onClick={() => handleToggleStatus(banner)}
                      title="Click to quickly toggle status"
                    >
                      <span className="dot"></span>
                      {banner.active ? "Active" : "Inactive"}
                    </button>
                  </div>
                </div>

                <div className="banner-card-actions">
                  <button className="banner-btn-edit" onClick={() => handleOpenModal(banner)}>
                    <Edit size={16} />
                    <span>Edit</span>
                  </button>
                  <button className="banner-btn-delete" onClick={() => handleDelete(banner.id)}>
                    <Trash2 size={16} />
                    <span>Delete</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {isModalOpen && createPortal(
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content fade-in" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingBanner ? 'Edit Banner' : 'Add New storefront Banner'}</h2>
              <button className="close-modal" type="button" onClick={handleCloseModal}><X size={20} /></button>
            </div>
            
            <form onSubmit={handleSubmit} className="banner-form">

                <div className="form-group">
                  <label>Select Banner Image</label>
                  <div className="banner-upload-wrapper">
                    {uploadPreview ? (
                      <div className="banner-preview-box">
                        <img src={uploadPreview} alt="Upload preview" />
                        <button 
                          type="button" 
                          className="banner-remove-upload"
                          onClick={() => {
                            setUploadedFile(null);
                            setUploadPreview(null);
                            setFormData(prev => ({ ...prev, image: '' }));
                          }}
                          title="Remove Image"
                        >
                          <X size={16} />
                        </button>
                      </div>
                    ) : (
                      <label htmlFor="banner-file-input" className="banner-upload-box">
                        <Upload size={32} />
                        <span>Click or Drag Image Here</span>
                        <small>PNG, JPG, WEBP up to 5MB</small>
                        <input
                          type="file"
                          id="banner-file-input"
                          hidden
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                      </label>
                    )}
                  </div>
                </div>


              <div className="form-group">
                <label>Redirect Destination Link</label>
                <input
                  type="text"
                  value={formData.link}
                  onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                  placeholder="e.g. /collection/sofa or /products/royal-lounge"
                />
                <small className="help-text">Where users land when clicking the banner on the front page.</small>
              </div>

              <div className="form-group">
                <label>Status</label>
                <select 
                  value={formData.active} 
                  onChange={(e) => setFormData({ ...formData, active: e.target.value === "true" })}
                >
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </select>
              </div>

              <div className="modal-actions">
                <button type="button" className="cancel-btn" onClick={handleCloseModal}>Cancel</button>
                <button type="submit" className="save-btn">
                  <Check size={18} />
                  <span>{editingBanner ? 'Update Banner' : 'Create Banner'}</span>
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}
    </MainLayout>
  );
};

export default Banners;
